module.exports = __webpack_public_path__ + "static/1-a01601f8fac24134b40b84533e9d36e4.jpg";